import {
  ToggleButton, ToggleButtonGroup,
} from '@mui/material';

interface ToggleFixedAspectProps {
  value: boolean;
  handleChange: (value: boolean) => void;
}

const ToggleFixedAspect = ({ value, handleChange }: ToggleFixedAspectProps) => (
    <ToggleButtonGroup
      size="small"
      color="primary"
      value={value}
      exclusive
      onChange={(event, value) => handleChange(value)}
    >
      <ToggleButton value>Locked Ratio</ToggleButton>
      <ToggleButton value={false}>Original Ratio</ToggleButton>
    </ToggleButtonGroup>
);

export default ToggleFixedAspect;
